import React from 'react'

export const UploadGuide = () => {
  return (
    <div className="w-full md:text-[18px] text-[14px] pb-[20px] mt-[10px] md:px-0 px-5">
      <ul className="list-disc pl-5 md:pl-28">
        <li className="mb-[8px]">
          프로, 프리미엄, 스페셜 플랜의 경우, 유튜브 권한 설정이 완료된 상태여야
          유튜브 자동 업로드가 가능합니다.
        </li>
        <li className="mb-[4px] leading-[28.8px]">
          플랜별 영상 생성 개수는 사용자가 ‘생성 요청한 영상’의 개수를 기준으로
          카운팅 합니다.
        </li>
        <li className="mb-[4px] leading-[28.8px]">
          영상 생성은 요청 후 24시간 내(최대 72시간)에 완료됩니다
        </li>
      </ul>
      <div className="ml-24 flex flex-col gap-1">
        <p>
          📢 영상 업로드 및 공개 일정 : 최초 자동업로드는 수동을 확인 후
          업로드하기에 최대 24시간 걸릴 수 있습니다.
        </p>
        <p>
          ✅ 영상 생성 후 자동 업로드 : 생성된 영상은 자동으로 공개 예약 상태로
          업로드됩니다.
        </p>
        <p>
          ⌛️ 영상 생성 및 업로드 소요 시간 : 일반적으로 약 1시간 정도
          소요됩니다.
        </p>
        <div>
          <p>📅 롱폼 프로, 프리미엄 플랜 영상 공개 일정</p>
          <ul className="list-disc pl-10 ">
            <li>
              생성된 영상은 다음날 10시, 14시, 18시에 순차적으로 공개됩니다.
            </li>
            <li>
              하루에 6개 이상의 영상을 생성한 경우, 초과된 영상은 이틀 후 10시,
              14시, 18시에 공개되도록 예약됩니다.
            </li>
          </ul>
        </div>

        <div>
          <p>📅 숏폼 스페셜 플랜 영상 공개 일정</p>
          <ul className="list-disc pl-10 ">
            <li>
              생성된 영상은 다음날 10시, 13시, 16시, 17시에 순차적으로
              공개됩니다.
            </li>
            <li>
              하루에 6개 이상의 영상을 생성한 경우, 초과된 영상은 이틀 후 10시,
              13시, 16시, 17시에 공개되도록 예약됩니다.
            </li>
          </ul>
        </div>
        <p>
          🎬 영상 확인 방법 : 업로드된 영상은 유튜브 스튜디오에서 확인
          가능합니다.
        </p>
        <p>
          📌 참고 : 공개 일정은 시스템에 의해 자동 설정되며, 변경이 필요할 경우
          유튜브 스튜디오에서 직접 수정 가능합니다.
        </p>
      </div>
    </div>
  )
}
